<template>
	<inertia-head title="Home" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">
						Insurance Information
					</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Please update your informaation for the insurance purpose
					</h2>
				</div>
			</div>
		</div>
	</div>

	<div class="content mt-5">
		<div class="row py-4">
			<div class="col-xl-9 m-auto">
				<div v-if="member.profile_complete==1 && !member.otp_sent" class="block block-rounded shadow">
					<div class="block-content block-content-full">
						<p class="text-center">Send OTP to my mobile# <strong>{{member.mobile}}</strong>| 
							<button type="button" @click="toggleModal" class="btn btn-sm btn-info">Edit Mobile</button>
						</p>
					</div>
					<div class="block-footer pb-5 text-center">
						<button @click="sendOTP" type="button" class="btn btn-success px-5">
							<span v-if="!form.processing"><i class="fa fa-envelope me-1"></i>SEND OTP</span>
							<span v-else>
								<div class="spinner-border spinner-border-sm text-dark" role="status" >
									<span class="sr-only mr-1">Please wait...</span>
								</div>
								<span class="mx-2">Please wait...</span>
							</span>
						</button>
					</div>
				</div>
				<div v-if="member.profile_complete==1 && member.otp_sent" class="block block-rounded shadow">
					<div class="block-content block-content-full">
						<div class="form-floating mb-4">
							<input v-model="formVerify.mobile_otp" type="text" id="otp" name="otp" class="form-control" placeholder="Please enter your OTP Number" />
							<label class="form-label">Please enter your OTP Number</label>
							<div v-if="formVerify.errors.mobile_otp && formVerify.mobile_otp==''" class="show-error">
								<i class="fa fa-exclamation-circle"></i>
								{{ formVerify.errors.mobile_otp }}
							</div>
						</div>
					</div>
					<div class="block-footer pb-3 text-center">
						<button @click="verifyOTP" type="button" class="btn btn-success px-5">
							<span v-if="!formVerify.processing"><i class="fa fa-check-circle me-1"></i>VERIFY OTP</span>
							<span v-else>
								<div class="spinner-border spinner-border-sm text-dark" role="status" >
									<span class="sr-only mr-1">Please wait...</span>
								</div>
								<span class="mx-2">Please wait...</span>
							</span>
						</button>
						<div v-if="seconds_remain>0" class="mt-4">
							<p class="m-0 fs-sm text-danger">Please wait 5 minutes before you can re-send the OTP</p>
							<p class="my-3 text-danger text-center">
								<label class="fw-bold">TIME</label>
								<div>
									<span class="border border-danger px-2 fw-bold">0{{minutes}}</span>
									<span class="fw-bold mx-1">:</span>
									<span class="border border-danger px-2 fw-bold">{{seconds}}</span>
								</div>
							</p>
						</div>
						<div v-else class="mt-4">
							Forgot your OTP Number? 
							<button @click="sendOTP" class="btn text-info m-0 p-0">
								<span v-if="!form.processing">Resend Here</span>
								<span v-else>
									<div class="spinner-border spinner-border-sm text-white" role="status" >
										<span class="sr-only mr-1">Please wait...</span>
									</div>
									<span class="mx-2">Please wait...</span>
								</span>
							</button>
							|<button type="button" @click="toggleModal" class="btn btn-sm text-info">Edit Mobile</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<modal ref="modal">
		<template #title>Confirmation</template>
		<template #body>
			<div class="form-floating mb-4">
				<!-- <input type="text" v-model="formUpdate.mobile" id="mobile" name="mobile" class="form-control" placeholder="Mobile Number"> -->
				<vue-tel-input
					@input="onInput"
					@countryChanged="onCountryChange"
					v-model="formUpdate.mobile"
					:value="formUpdate.mobile"
					class="form-control"
					:class="{ 'is-invalid': formUpdate.errors.mobile }"
					:input-options="{
						placeholder: 'Enter mobile number',
					}"
					:defaultCountry="formUpdate.country_code"
					mode="international"
				/>
				<label class="form-label">Mobile Number</label>
				<div v-if="formUpdate.errors.mobile && formUpdate.mobile==''" class="show-error">
					<i class="fa fa-exclamation-circle"></i>
					{{ formUpdate.errors.mobile }}
				</div>
			</div>
		</template>
		<template #footer>
			<button type="button" @click="updateMobile" class="btn btn-alt-success">
				<span v-if="!formUpdate.processing">Update</span>
				<span v-else>
					<div class="spinner-border spinner-border-sm text-dark" role="status" >
						<span class="sr-only mr-1">Please wait...</span>
					</div>
					<span class="mx-2">Please wait...</span>
				</span>
			</button>
			<button @click="toggleModal" type="button" class="btn btn-alt-danger">
				Cancel
			</button>
		</template>
	</modal>

</template>

<script>
import { watch, ref, onMounted } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import AuthLayout from '../../../Layouts/AuthLayout'
import { createToaster } from '@meforma/vue-toaster'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	props:{
		flash 				: Object,
		errors 				: Object,
		member 				: Object,
		seconds 			: Number,
		api_response		: Object
	},
	layout: AuthLayout,
	setup(props) {

		const toast 			= createToaster();
		const seconds_remain 	= ref(props.seconds);
		const minutes 			= ref(0);
		const seconds 			= ref('00');

		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
			formUpdate.mobile 				= props.member.mobile??'';
			formUpdate.country_calling_code = props.member.country_calling_code??'';
			formUpdate.country_code 		= props.member.country_code??'';
		}

		const action_take = ref('send');
		
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
			{
				pageContainer.classList.remove('sidebar-o-xs')
			}
			
			// if(props.flash)
			// {
			// 	toast.show(props.flash.message, { type: "success"});
			// }
			countdown();
		})


		var countdown = ()=>{
							if(seconds_remain.value>0)
							{
								seconds_remain.value--;

								minutes.value = parseInt(seconds_remain.value / 60);
								seconds.value = parseInt(seconds_remain.value - (minutes.value*60));
								seconds.value = ((seconds.value).toString()).length<2 ? '0'+seconds.value : seconds.value;

								setTimeout(function(){
									countdown();
								},1000)
							}
						}

		
		const form = useForm({
						mobile : props.member.mobile??''
					});

		const formUpdate = useForm({
						mobile 					: '',
						country_calling_code 	: '',
						country_code 			: '',
					});

		const formVerify = useForm({
							mobile_otp 	: '',
						});

		const onInput = (number, phoneObject) => {
			if (phoneObject?.formatted) {
				formUpdate.mobile 					= phoneObject.number;
				formUpdate.country_calling_code 	= phoneObject.countryCallingCode;
			}
		}

		const onCountryChange = (countryObject) => {
			formUpdate.country_code = countryObject.iso2
		}

		const updateMobile = ()=>{
			action_take.value = 'send';
			formUpdate.put("update-mobile/"+props.member.member_uuid,{
				preserveState: true,
				preserveScroll: true,
				only:['errors','flash','api_response','member','seconds'],
				onSuccess: () => toggleModal()
			})
		}

		const sendOTP = ()=>{
			action_take.value = 'send';
			form.put("send-otp/"+props.member.member_uuid,{
				preserveState: true,
				preserveScroll: true,
				only:['errors','flash','api_response','member','seconds']
			})
		}

		const verifyOTP = ()=>{
			action_take.value = 'verify';
			formVerify.put("verify-otp/"+props.member.member_uuid,{
				preserveState: true,
				preserveScroll: true,
				only:['errors','flash','api_response','member']
			})
		}

		watch(()=>props.api_response,(response)=>{
			
			if(response!=null)
			{
				if(response.result=="success")
				{

					if(response.data=="update_mobile")
					{
						toast.show("Successfully updated.", { type: response.result});
					}else
					{
						action_take.value = action_take.value=='send' ?'sent':'verified';

						seconds_remain.value = props.seconds;

						if(action_take.value=='sent')
						{
							countdown();
						}

						toast.show("OTP was successfully "+action_take.value, { type: response.result});
					}
					
				}else
				{
					if(response.data=="update_mobile")
					{
						toast.show("Failed to update", { type: "error"});
					}else
					{
						toast.show(`Failed to ${action_take.value} OTP`, { type: "error"});
					}
				}
			}
		})

		return{
			modal,
			toggleModal,
			seconds_remain,
			minutes,
			seconds,
			countdown,
			action_take,
			toast,
			form,
			onInput,
			onCountryChange,
			formUpdate,
			formVerify,
			updateMobile,
			sendOTP,
			verifyOTP,
		}

	},
}
</script>
